// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzbXMtZGFzaGJvYXJkLmNvbXBvbmVudC5jc3MifQ== */", "",{"version":3,"sources":["webpack://./src/app/component/sms/sms-dashboard/sms-dashboard.component.css"],"names":[],"mappings":";AACA,4KAA4K","sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
